module.exports = __webpack_public_path__ + "img/app_hover.cb5470dc.png";